import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { IconPosition, LoaderTheme } from '@fcom/ui-components';

export interface OndMarketingLinkListItem {
  href: string;
  args: Record<string, string>;
  disabled?: boolean;
}

export interface OndMarketingLinkGroup {
  headingArgs?: Record<string, string>;
  links: OndMarketingLinkListItem[];
}

@Component({
  selector: 'fin-ond-marketing-link-list',
  templateUrl: './ond-marketing-link-list.component.html',
  styleUrls: ['./ond-marketing-link-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OndMarketingLinkListComponent {
  readonly heading = input.required<string>();
  readonly headingLevel = input<1 | 2>(1);
  readonly icon = input<SvgLibraryIcon>(SvgLibraryIcon.CONNECTING_FLIGHT);
  readonly labelKey = input.required<string>();
  readonly groupHeadingKey = input<string>('ondMarketing.flightsFrom');
  readonly groups = input<OndMarketingLinkGroup[]>();
  readonly loading = input<boolean>(false);
  readonly loaderType = input<LoaderTheme>(LoaderTheme.EMBEDDED);

  readonly IconPosition = IconPosition;
  readonly SvgLibraryIcon = SvgLibraryIcon;
}
